// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__kXlYa {
  width: 100%;
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  background-color: #333;
  flex-direction: column;
}

.Footer_container__R7sXj {
  max-width: 1140px;
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-family: Arial, sans-serif;
}

.Footer_column__iAwVm {
  flex: 1 1;
}

.Footer_h3__TBuC5 column {
  font-size: 1.2em;
  margin-bottom: 20px;
  font-weight: normal;
}

ul {
  padding: 0;
  margin: 0;
}
ul li {
  margin-left: 0;
}

.Footer_links__wMgLO {
  list-style: none; /* Elimină punctele implicite din listă */
  padding: 0; /* Elimină padding-ul implicit */
  margin: 0; /* Elimină marginile implicite */
}

.Footer_links__wMgLO li {
  margin-bottom: 5px; /* Elimină orice margine implicită */
}

.Footer_links__wMgLO a {
  color: red;
  text-decoration: none;
}

.Footer_links__wMgLO a:hover {
  text-decoration: underline;
}

.Footer_contactList__9bBgR {
  margin-top: 10px; /* Spațiu între titlu și lista de contacte */
  display: flex;
  flex-direction: column; /* Elemente pe verticală */
  align-items: flex-start; /* Aliniază tot conținutul la stânga */
}

.Footer_contactItem__Ztmhc {
  display: flex;
  flex-direction: row; /* Elemente pe verticală */
  align-items: flex-start; /* Aliniază tot conținutul la stânga */
  margin-bottom: 15px; /* Spațiu între fiecare pereche locație-telefon */
  align-items: baseline;
}

.Footer_contactItem__Ztmhc p {
  max-width: 25%;
}

.Footer_location__Djhrn {
  text-align: left; /* Text aliniat la stânga */
  color: #fff;
  font-size: 1rem;
  margin-bottom: 5px; /* Spațiu între locație și număr */
  width: 150px; /* Lățime fixă pentru locație pentru aliniere perfectă */
}

.Footer_phone__1gD82 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 10px;
  color: red;
  text-decoration: none;
  border: 1px solid red;
  border-radius: 5px;
  font-size: 0.9rem;
  width: 120px; /* Lățime fixă pentru număr pentru aliniere perfectă */
  margin-left: 10px;
}

.Footer_phone__1gD82 i {
  margin-right: 5px; /* Spațiu între icon și text */
}

.Footer_phone__1gD82:hover {
  background-color: red;
  color: #fff;
}
.Footer_socialIcons__JZqJ0 {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.Footer_icon__Zscac {
  display: inline-block;
  width: 40px;
  height: 40px;
  background-color: #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
  text-decoration: none;
  font-size: 1.2em;
}

.Footer_icon__Zscac:hover {
  background-color: rgb(236, 227, 227);
}

.Footer_icon__Zscac i {
  flex: 1 1;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.Footer_facebookColor__NAqy2 {
  color: #0866ff;
}

.Footer_twitterColor__EtMuQ {
  color: #1c96e8;
}

.Footer_linkedinColor__vOtpL {
  color: #0a66c2;
}

.Footer_mailColor__KUlGV {
  color: #ea4335;
}

.Footer_copyright__JQMtz {
  margin-top: 20px;
  font-size: 0.8em;
  color: #aaa;
}

.Footer_description__UJWcL {
  margin-top: 45px;
  text-align: right; /* Text aliniat la stânga */
  color: #fff;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .Footer_container__R7sXj {
    flex-direction: column; /* Elemente afișate în coloană */
    align-items: center; /* Elemente centrate pe orizontală */
    padding: 0 15px; /* Spațiu pe margini pentru a evita depășirea */
  }

  .Footer_column__iAwVm {
    margin-bottom: 20px; /* Spațiu între coloane */
    flex: none; /* Elimină flex-grow */
    width: 100%; /* Lățime completă */
    text-align: center; /* Aliniere centrală pentru conținut */
  }

  .Footer_column__iAwVm h3 {
    text-align: center; /* Aliniere centrală pentru titluri */
  }

  .Footer_contactList__9bBgR {
    display: flex;
    width: 100%;
    align-items: center; /* Elemente centrate pe orizontală */
    justify-content: center;
  }

  .Footer_phone__1gD82 {
    width: auto; /* Elimină lățimea fixă */
    margin-left: 0; /* Elimină spațiul lateral */
    margin-top: 5px; /* Adaugă spațiu între locație și telefon */
  }

  .Footer_socialIcons__JZqJ0 {
    justify-content: center; /* Iconițele social media centrate */
    gap: 15px; /* Spațiu mai mare între iconițe */
  }

  .Footer_description__UJWcL {
    text-align: center; /* Text centrat */
    margin-top: 20px; /* Spațiu mai mic pentru descriere */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB,EAAE,yCAAyC;EAC3D,UAAU,EAAE,gCAAgC;EAC5C,SAAS,EAAE,gCAAgC;AAC7C;;AAEA;EACE,kBAAkB,EAAE,oCAAoC;AAC1D;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB,EAAE,4CAA4C;EAC9D,aAAa;EACb,sBAAsB,EAAE,0BAA0B;EAClD,uBAAuB,EAAE,sCAAsC;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,0BAA0B;EAC/C,uBAAuB,EAAE,sCAAsC;EAC/D,mBAAmB,EAAE,iDAAiD;EACtE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB,EAAE,2BAA2B;EAC7C,WAAW;EACX,eAAe;EACf,kBAAkB,EAAE,kCAAkC;EACtD,YAAY,EAAE,wDAAwD;AACxE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY,EAAE,sDAAsD;EACpE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB,EAAE,8BAA8B;AACnD;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB,EAAE,2BAA2B;EAC9C,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB,EAAE,gCAAgC;IACxD,mBAAmB,EAAE,oCAAoC;IACzD,eAAe,EAAE,+CAA+C;EAClE;;EAEA;IACE,mBAAmB,EAAE,yBAAyB;IAC9C,UAAU,EAAE,sBAAsB;IAClC,WAAW,EAAE,oBAAoB;IACjC,kBAAkB,EAAE,sCAAsC;EAC5D;;EAEA;IACE,kBAAkB,EAAE,qCAAqC;EAC3D;;EAEA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB,EAAE,oCAAoC;IACzD,uBAAuB;EACzB;;EAEA;IACE,WAAW,EAAE,yBAAyB;IACtC,cAAc,EAAE,4BAA4B;IAC5C,eAAe,EAAE,2CAA2C;EAC9D;;EAEA;IACE,uBAAuB,EAAE,oCAAoC;IAC7D,SAAS,EAAE,kCAAkC;EAC/C;;EAEA;IACE,kBAAkB,EAAE,iBAAiB;IACrC,gBAAgB,EAAE,oCAAoC;EACxD;AACF","sourcesContent":[".footer {\n  width: 100%;\n  display: flex;\n  margin: auto;\n  justify-content: center;\n  align-items: center;\n  margin-top: 10px;\n  background-color: #333;\n  flex-direction: column;\n}\n\n.container {\n  max-width: 1140px;\n  display: flex;\n  justify-content: space-between;\n  color: #fff;\n  font-family: Arial, sans-serif;\n}\n\n.column {\n  flex: 1;\n}\n\n.h3 column {\n  font-size: 1.2em;\n  margin-bottom: 20px;\n  font-weight: normal;\n}\n\nul {\n  padding: 0;\n  margin: 0;\n}\nul li {\n  margin-left: 0;\n}\n\n.links {\n  list-style: none; /* Elimină punctele implicite din listă */\n  padding: 0; /* Elimină padding-ul implicit */\n  margin: 0; /* Elimină marginile implicite */\n}\n\n.links li {\n  margin-bottom: 5px; /* Elimină orice margine implicită */\n}\n\n.links a {\n  color: red;\n  text-decoration: none;\n}\n\n.links a:hover {\n  text-decoration: underline;\n}\n\n.contactList {\n  margin-top: 10px; /* Spațiu între titlu și lista de contacte */\n  display: flex;\n  flex-direction: column; /* Elemente pe verticală */\n  align-items: flex-start; /* Aliniază tot conținutul la stânga */\n}\n\n.contactItem {\n  display: flex;\n  flex-direction: row; /* Elemente pe verticală */\n  align-items: flex-start; /* Aliniază tot conținutul la stânga */\n  margin-bottom: 15px; /* Spațiu între fiecare pereche locație-telefon */\n  align-items: baseline;\n}\n\n.contactItem p {\n  max-width: 25%;\n}\n\n.location {\n  text-align: left; /* Text aliniat la stânga */\n  color: #fff;\n  font-size: 1rem;\n  margin-bottom: 5px; /* Spațiu între locație și număr */\n  width: 150px; /* Lățime fixă pentru locație pentru aliniere perfectă */\n}\n\n.phone {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 5px 10px;\n  color: red;\n  text-decoration: none;\n  border: 1px solid red;\n  border-radius: 5px;\n  font-size: 0.9rem;\n  width: 120px; /* Lățime fixă pentru număr pentru aliniere perfectă */\n  margin-left: 10px;\n}\n\n.phone i {\n  margin-right: 5px; /* Spațiu între icon și text */\n}\n\n.phone:hover {\n  background-color: red;\n  color: #fff;\n}\n.socialIcons {\n  margin-top: 10px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.icon {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  background-color: #fff;\n  text-align: center;\n  line-height: 40px;\n  border-radius: 5px;\n  text-decoration: none;\n  font-size: 1.2em;\n}\n\n.icon:hover {\n  background-color: rgb(236, 227, 227);\n}\n\n.icon i {\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n}\n\n.facebookColor {\n  color: #0866ff;\n}\n\n.twitterColor {\n  color: #1c96e8;\n}\n\n.linkedinColor {\n  color: #0a66c2;\n}\n\n.mailColor {\n  color: #ea4335;\n}\n\n.copyright {\n  margin-top: 20px;\n  font-size: 0.8em;\n  color: #aaa;\n}\n\n.description {\n  margin-top: 45px;\n  text-align: right; /* Text aliniat la stânga */\n  color: #fff;\n  font-size: 1rem;\n}\n\n@media (max-width: 768px) {\n  .container {\n    flex-direction: column; /* Elemente afișate în coloană */\n    align-items: center; /* Elemente centrate pe orizontală */\n    padding: 0 15px; /* Spațiu pe margini pentru a evita depășirea */\n  }\n\n  .column {\n    margin-bottom: 20px; /* Spațiu între coloane */\n    flex: none; /* Elimină flex-grow */\n    width: 100%; /* Lățime completă */\n    text-align: center; /* Aliniere centrală pentru conținut */\n  }\n\n  .column h3 {\n    text-align: center; /* Aliniere centrală pentru titluri */\n  }\n\n  .contactList {\n    display: flex;\n    width: 100%;\n    align-items: center; /* Elemente centrate pe orizontală */\n    justify-content: center;\n  }\n\n  .phone {\n    width: auto; /* Elimină lățimea fixă */\n    margin-left: 0; /* Elimină spațiul lateral */\n    margin-top: 5px; /* Adaugă spațiu între locație și telefon */\n  }\n\n  .socialIcons {\n    justify-content: center; /* Iconițele social media centrate */\n    gap: 15px; /* Spațiu mai mare între iconițe */\n  }\n\n  .description {\n    text-align: center; /* Text centrat */\n    margin-top: 20px; /* Spațiu mai mic pentru descriere */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__kXlYa`,
	"container": `Footer_container__R7sXj`,
	"column": `Footer_column__iAwVm`,
	"h3": `Footer_h3__TBuC5`,
	"links": `Footer_links__wMgLO`,
	"contactList": `Footer_contactList__9bBgR`,
	"contactItem": `Footer_contactItem__Ztmhc`,
	"location": `Footer_location__Djhrn`,
	"phone": `Footer_phone__1gD82`,
	"socialIcons": `Footer_socialIcons__JZqJ0`,
	"icon": `Footer_icon__Zscac`,
	"facebookColor": `Footer_facebookColor__NAqy2`,
	"twitterColor": `Footer_twitterColor__EtMuQ`,
	"linkedinColor": `Footer_linkedinColor__vOtpL`,
	"mailColor": `Footer_mailColor__KUlGV`,
	"copyright": `Footer_copyright__JQMtz`,
	"description": `Footer_description__UJWcL`
};
export default ___CSS_LOADER_EXPORT___;
